import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { flexDirection: string; loading: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    root: {
      borderRadius: 12,
      width: '100%',
      maxWidth: '684px',
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
      justifyContent: 'center',
      alignItems: 'center',
      marginBlockStart: 32,

      [mediaQuery(breakpoints.mobile)]: {
        padding: [0, 24],
      },
    },
    animation: {
      backgroundColor: 'var(--x-bg-7)',
      animation: 'blinker 3s linear infinite',
    },
    largeContainer: {
      borderRadius: 12,
      width: '100%',
      height: 124,
    },
    smallContainer: {
      borderRadius: 12,
      width: '178px',
      height: 48,
      marginTop: 8,

      [mediaQuery(breakpoints.mobile)]: {
        width: '100%',
      },
    },
  }),
  { name: 'LoadingResults' },
);
export default useStyles;
